import NavigationControls from "./NavigationControls";

export default NavigationControls;
